import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { keyBy } from 'lodash';

type OptionsConfig<T> = { keyName: keyof T; keyValue: keyof T };

export interface FilterOption<V> {
  name: string;
  value: V;
}

export function mapToFilterOptions<L, V extends L[keyof L]>({
  keyName,
  keyValue,
}: OptionsConfig<L>) {
  return pipe(
    map((list: L[]) => {
      const itemByName = keyBy(filterByDefinedKey(list, keyName), keyName);
      const names = _definedValues(Object.keys(itemByName));

      return names.map((name) => ({
        name: name.replace(/_/g, ' ').trim(),
        value: itemByName[name][keyValue] as V,
      }));
    })
  );
}

function _definedValues<V>(values: V[]): V[] {
  return values.filter((value) => !!value);
}

function filterByDefinedKey<L>(list: L[], keyName: keyof L) {
  return list.filter((item) => !!item[keyName]);
}
